module.exports = __webpack_public_path__ + "img/CODINAFRICA.cad66dbb.png";